module.exports = __webpack_public_path__ + "static/media/sofa1x1.96240c65.svg";